import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const variant_list = async (data: {
  filter: {
    query: string | null;
    categoryId: string | null;
    brandId: string | null;
    warehouseId: string | null;
  };
  offset: {
    page: number;
    limit: number;
  };
  businessId: string;
}) => httpRequest.get("/erp/invoice/variant", data);

export const warehouses = async () => httpRequest.get("/erp/business/warehouses");
